// Module
var code = "<div> <div froala-view=\"newContent\"></div> </div>";
// Exports
module.exports = code;